"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function Consultation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="3422" id="consultationcta" className="bg-background text-foreground w-full max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-28 lg:py-32">
      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto text-left transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <span className="font-mono text-xs uppercase tracking-widest text-secondary block mb-4">
          日本語でのご相談
        </span>

        <h2 className="font-serif font-bold text-primary text-2xl md:text-3xl lg:text-4xl mb-6">
          フロリダ州での法的トラブル、ビジネス、不動産売買、遺産相続に関するご相談を受け付けております。
        </h2>

        <div className="font-sans text-muted-foreground prose max-w-3xl text-base md:text-lg leading-relaxed space-y-4">
          <p>
            当事務所では、ご希望に応じて日本語でのご連絡や資料のやり取りに対応しております。フロリダ州法に関するご相談の際は、日本語でのご意向をお知らせください。
          </p>
          <p>
            <Link to="/InitialContactInJapanesePage" className="text-primary font-medium hover:underline inline-flex items-center gap-1">
              日本語での初期連絡について →
            </Link>
          </p>
          <p>
            <Link to="/JapaneseStaffPage" className="text-primary font-medium hover:underline inline-flex items-center gap-1">
              スタッフ紹介 →
            </Link>
          </p>
        </div>

        <p className="font-sans text-foreground/80 mt-6">
          初回のお問い合わせは、専用の日本語フォームより承っております。内容を確認の上、担当者よりご連絡いたします。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-start gap-6">
          <Link to="/InitialContactInJapanesePage" aria-label="日本語での初期連絡">
            <Button size="lg" className="bg-primary text-primary-foreground px-6 py-3 font-mono text-xs md:text-sm uppercase tracking-widest rounded-md shadow-md hover:bg-primary/90 transition-colors">
              日本語での初期連絡
              <ArrowRight className="ml-2 size-4" />
            </Button>
          </Link>
        </div>

        <p className="font-sans text-sm text-muted-foreground mt-8 prose max-w-3xl">
          ※フォームの送信のみでは弁護士とクライアントの関係は成立いたしません。正式なご依頼の前に、利益相反の確認および契約手続きが必要となります。
        </p>
      </div>
    </section>;
}